import useMountEffect from "hooks/mount-effect"
import { useAnalytics } from "connected-components/analytics"
import { SHARED_EVENTS } from "connected-components/analytics/shared/events"

export function useFactorsViewLoadedTracking() {
  const analytics = useAnalytics()

  useMountEffect(() => {
    analytics.track(SHARED_EVENTS.LOADED)
  })
}
